module.exports = __webpack_public_path__ + "img/75_24.d535bbec.png";